import React from 'react';
import { Datagrid, List, TextField } from 'react-admin';

import DateField from '../../../Common/Utils/DateField';
import DefaultSort from '../../../Common/Partials/DefaultSort';
import ListActions from './Helpers/ListActions';
import StatusField from '../../../Common/Partials/StatusField';
import ReportLinkedPlacementTitleName from './StaticData/TitleName';
import SearchFilter from './Helpers/SearchFilter';

const ReportLinkedPlacementList = (props) => (
  <List actions={<ListActions {...props} />} filters={<SearchFilter />} title={ReportLinkedPlacementTitleName} sort={DefaultSort} perPage={25} bulkActionButtons={false} {...props}>
    <Datagrid>
      <TextField source="code" />
      <TextField source="name" />
      <StatusField source="active" record={props.record} />
      <TextField source="placement_name" sortable={false} />
      <TextField source="domain_filters" sortable={false} />
      <DateField name="updated_at" source="updated_at" />
    </Datagrid>
  </List>
);

export default ReportLinkedPlacementList;



// WEBPACK FOOTER //
// ./src/views/Components/Reports/LinkedPlacements/List.tsx